import React from 'react'
import { FaMagnifyingGlass } from 'react-icons/fa6';

const Search = ({ isMobile = false, isCompact = false }) => {
    return (
        <div className={`flex flex-row w-full items-center rounded-full bg-white transition-all duration-300 shrink-0 ${
            isCompact 
                ? 'h-5 pl-0.5 space-x-1' 
                : isMobile 
                    ? 'h-7 pl-1 space-x-1' 
                    : 'h-7 pl-1 space-x-4'
        }`}>
            <button className='flex w-5 h-5 rounded-full items-center justify-center text-heading shrink-0'>
                <FaMagnifyingGlass size={isCompact ? 12 : isMobile ? 14 : 16}/>
            </button>
            <input 
                className='w-full text-heading text-sm tracking-wider bg-transparent focus:outline-hidden placeholder-heading min-w-0' 
                placeholder={isMobile ? 'Search...' : 'Search...'}
            />
        </div>
    )
}

export default Search